// extracted by mini-css-extract-plugin
export default {"middle":"styles_middle__dhnJA","image":"styles_image__h1Qdc","title":"styles_title__GosvF","loading":"styles_loading__mzECj","grid_container":"styles_grid_container__wh5R7"};